import type React from "react";
import "./AppComponents.css";

export function AppHeading1(props: { children?: React.ReactNode }) {
    const { children } = props;
    return <div className="app-h1">{children}</div>;
}

export function AppHeading2(props: { children?: React.ReactNode }) {
    const { children } = props;
    return <div className="app-h2">{children}</div>;
}

export function AppHeading3(props: { children?: React.ReactNode }) {
    const { children } = props;
    return <div className="app-h3">{children}</div>;
}

export function AppHeading5(props: { children?: React.ReactNode }) {
    const { children } = props;
    return <div className="app-h5">{children}</div>;
}

export function AppParagraph(props: { children?: React.ReactNode }) {
    const { children } = props;
    return <div className="app-p">{children}</div>;
}

export function AppParagraphs(props: { text: string | undefined | null }) {
    const { text } = props;
    const paragraphs = text ? text.split(/\n+/) : [""];
    return (
        <>
            {paragraphs.map((p, i) => (
                <AppParagraph key={String(i)}>{p}</AppParagraph>
            ))}
        </>
    );
}

export function AppButton(props: { children?: React.ReactNode }) {
    const { children } = props;
    return <div className="app-button">{children}</div>;
}

export function AppDashedLine() {
    return <div className="app-dashed-line" />;
}
